import { render, staticRenderFns } from "./PatentIndex.vue?vue&type=template&id=27f21e88&scoped=true&"
import script from "./PatentIndex.vue?vue&type=script&lang=ts&"
export * from "./PatentIndex.vue?vue&type=script&lang=ts&"
import style0 from "./PatentIndex.vue?vue&type=style&index=0&id=27f21e88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f21e88",
  null
  
)

export default component.exports